export const blockIconsSocialSentimentDissatisfiedNew = (
	<span className='material-symbols-outlined'>sentiment_dissatisfied</span>
);
